import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import {JobState} from './JobState'
import { CareerState } from './CareerState';
import { ProfileState } from './ProfileState';
import { UsageOverviewState } from './UsageOverviewState'

export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
        job_state: JobState(),
        career_state: CareerState(),
        profile_state:ProfileState(),
        usage_state:UsageOverviewState()
    }
}